import { createNativeStackNavigator } from "@react-navigation/native-stack";

import { AuthenticatedUsersHorizontalList } from "../../OS/AuthenticatedUsers/AuthenticatedUsersHorizontalList";
import { FinishedSetupScreen } from "./FinishedSetupScreen";
import { OnboardingNavigatorParamList } from "./navigationParams";
import React from "react";
import { SetNameScreen } from "./SetNameScreen";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { Box } from "arkh";
import { useUser } from "../../OS/Login/State";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { OnboardingQuery } from "./__generated__/OnboardingQuery.graphql";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { usePollFetchKey } from "widgets/src/usePollFetchKey";

const OnboardingNavigator =
  createNativeStackNavigator<OnboardingNavigatorParamList>();

export function Onboarding(
  props: UserLoggedInNavigatorScreenProps<"Onboarding">
) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => <InnerOnboarding {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}
function InnerOnboarding(
  props: UserLoggedInNavigatorScreenProps<"Onboarding"> & { fetchKey: string }
) {
  const localUser = useUser();

  const pollToken = usePollFetchKey(
    localUser.user ? 5000 : null,
    props.fetchKey
  );
  useLazyLoadQuery<OnboardingQuery>(
    graphql`
      query OnboardingQuery {
        me {
          flags
        }
      }
    `,
    {},
    {
      fetchKey: pollToken,
      fetchPolicy: "store-and-network",
    }
  );

  const insets = useSafeAreaInsets();

  return (
    <Box style={{ flex: 1 }} insets={insets}>
      <AuthenticatedUsersHorizontalList backgroundColor="surface" />
      <OnboardingNavigator.Navigator
        screenOptions={{
          headerShown: false,
        }}
      >
        <OnboardingNavigator.Screen
          name="OnboardingSetName"
          component={SetNameScreen}
        />

        <OnboardingNavigator.Screen
          name="OnboardingFinishedSetup"
          component={FinishedSetupScreen}
        />
      </OnboardingNavigator.Navigator>
    </Box>
  );
}
